import { useAssessmentContext } from '../context/assessment';
import PolicyService from '../services/PolicyService';

export default function usePolicyManager()
{
	const assessmentContext = useAssessmentContext();

	const getPolicyId = async (questionId: string, policyNumber: string, postcode?: string, dateOfBirth?: string, emailAddress?: string): Promise<number | null> =>
	{
		const assessment = assessmentContext.assessment;
		if (!assessment)
			return null;

		const policyId = await new PolicyService().getPolicyId(assessment.assessmentId, assessment.version, questionId, policyNumber, postcode, dateOfBirth, emailAddress)
			.catch(e =>
			{
				console.error(e);
				return null;
			});

		if (!policyId)
			return null;

		return policyId;
	}

	return { getPolicyId } as const;
}
